export const blockIconsHardwareMemory = (
	<span className='material-symbols-outlined'>memory</span>
);
